module.exports = __webpack_public_path__ + "img/video-thumb-5-nl.dd42e95c.png";